import React, { useState } from "react";

import { useAppSelector } from "../../../Store/Hooks";
import { ROLES, isRole } from "../../../Utils/Constants/RoleConstants";
import {
  STORAGE_KEYS,
  getFromLocalStorage,
} from "../../../Utils/Helper/LocalStorage";
import TemplateList from "../../TemplateContainer/components/TemplateList";
import "./style.scss";

const VendorTemplatesContainer: React.FC = () => {
  const { user } = useAppSelector(state => state.authentication);
  const loggedInUser = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
  const reduxUserRole = user?.user?.role;
  const storageUserRole = loggedInUser?.role;
  const userRole = reduxUserRole || storageUserRole;

  const isSuperAdmin = isRole(userRole, ROLES.IZBA_ADMIN);
  const isAdmin = isRole(userRole, ROLES.VENDOR_ADMIN);

  const [activeTab, setActiveTab] = useState<"izba_provided" | "custom">(
    "izba_provided"
  );

  const handleTabChange = (tab: "izba_provided" | "custom") => {
    setActiveTab(tab);
  };

  return (
    <div className="vendor-templates-container">
      <TemplateList
        maxShortTemplates={null}
        maxLongTemplates={null}
        isSuperAdmin={isSuperAdmin}
        isAdmin={isAdmin}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default VendorTemplatesContainer;
